export default [

	...middleware('guest', [
		{ path: '/', name: 'landing-page', component: () => import('@/pages/guest/LandingPage') },
		{ path: '/login', name: 'sign-in', component: () => import('@/pages/guest/SignIn') },
		{ path: '/signup', name: 'sign-up', component: () => import('@/pages/guest/SignUp') },
		{ path: '/signup-success', name: 'sign-up-success', component: () => import('@/pages/guest/SignUpSuccess') },
		{ path: '/forgot-password', name: 'forgot-password', component: () => import('@/pages/guest/ForgotPassword') },
		{ path: '/change-password/:token', name: 'change-password', component: () => import('@/pages/guest/ChangePassword') },
		{ path: '/change-password-success', name: 'change-password-success', component: () => import('@/pages/guest/ChangePasswordSuccess') }
	]),

	...middleware('auth', [
		{
			path: '/',
			component: () => import('@/pages/home/Home'),
			name: 'home',
			children: [
				{
					path: '/dashboard',
					name: 'dashboard',
					component: () => import('@/pages/home/Dashboard')
				},

				{
					path: '/frequently-asked-question',
					name: 'frequently-asked-question',
					props: true,
					component: () => import('@/pages/home/FrequentlyAskedQuestion')
				},

				{
					path: '/library',
					name: 'library',
					component: () => import('@/pages/home/VideoLibrary'),
					meta: {}
				},

				{
					path: '/session',
					name: 'session',
					component: () => import('@/pages/home/SessionList'),
					meta: {}
				},

				{
					path: '/session/create',
					name: 'session-create',
					component: () => import('@/components/session/SessionCreateLayout'),
					meta: {
					}
				},

				// {
				// 	path: '/session/create-custom',
				// 	name: 'session-create-custom',
				// 	component: () => import('@/pages/home/SessionCreateCustom'),
				// 	meta: {
				// 		origin: 'session-create'
				// 	}
				// },

				// {
				// 	path: '/session/create-prebuilt',
				// 	name: 'session-create-prebuilt',
				// 	component: () => import('@/pages/home/SessionCreatePrebuilt'),
				// 	meta: {
				// 		origin: 'session-create'
				// 	}
				// },

				// {
				// 	path: '/session/edit/:sessionId',
				// 	name: 'session-edit',
				// 	component: () => import('@/pages/home/SessionEdit'),
				// 	meta: {
				// 		origin: ''
				// 	}
				// },

				{
					path: '/session/view/:sessionId/:sessionType',
					name: 'session-view',
					component: () => import('@/pages/home/SessionView'),
					meta: {}
				},

				{
					path: '/post/session/view/:sessionId/:sessionType',
					name: 'post-session-view',
					component: () => import('@/pages/home/PostSessionView'),
					meta: {}
				},

				// {
				// 	path: '/session/view-prebuilt/:sessionId/:sessionType',
				// 	name: 'session-view-prebuilt',
				// 	props: true,
				// 	component: () => import('@/pages/home/SessionViewPrebuilt'),
				// 	meta: {
				// 		origin: 'session',
				// 		headless: true
				// 	}
				// },

				// {
				// 	path: '/session/school-solution-view/:sessionId',
				// 	name: 'session-school-solution-view',
				// 	props: true,
				// 	component: () => import('@/pages/home/SessionSchoolSolutionView'),
				// 	meta: {
				// 		origin: 'session',
				// 		headless: true
				// 	}
				// },

				{
					path: '/users',
					name: 'users',
					component: () => import('@/pages/home/UserList'),
					meta: {}
				},

				{
					path: '/user-view/:id',
					name: 'user-view',
					component: () => import('@/pages/home/UserView'),
					meta: {}
				},

				{
					path: '/session/user-view/:sessionId/:userId/:date',
					name: 'session-user',
					component: () => import('@/pages/home/SessionUser'),
					props: true,
					meta: {
						origin: ''
					}
				},

				{
					path: '/archive',
					name: 'archive',
					component: () => import('@/pages/home/SessionArchive'),
					meta: {}
				},

				{
					path: '/archive/view/:id',
					name: 'archive-session-view',
					component: () => import('@/pages/home/SessionView'),
					props: true,
					meta: {
						origin: 'archive'
					}
				},

				{
					path: '/archive/view/:sessionId/:userId/:date',
					name: 'archive-user-view',
					component: () => import('@/pages/home/SessionView'),
					props: true,
					meta: {
						origin: 'archive'
					}
				},

				{
					path: '/upmood-mass',
					name: 'upmood-mass',
					component: () => import('@/pages/home/UpmoodMassList'),
					meta: {}
				},

				{
					path: '/upmood-mass/view/:id',
					name: 'upmood-mass-view',
					component: () => import('@/pages/home/UpmoodMassView'),
					props: true,
					meta: {
						origin: 'upmood-mass',
						title: 'Upmood Mass Insight'
					}
				}
			]
		},

		{ path: '*', name: 'PageNotFound', component: () => import('@/pages/errors/PageNotFound') }
	]),

	...middleware('all', [
		{
			path: '/generate-report', name: 'generate-report', component: () => import('@/pages/all/pdf-report/GenerateReport'), props: true
		},

		{ path: '/verify*', name: 'verify', component: () => import('@/pages/guest/Verify') },

		{
			path: '/quick-access/:routerId',
			name: 'quick-access',
			component: () => import('@/pages/all/QuickAccess'),
			props: true,
			meta: {
				title: 'Quick Access',
				headless: true
			}
		},

		{
			path: '/user-display',
			name: 'user-display',
			component: () => import('@/pages/home/SessionUserDisplay'),
			meta: {
				headless: true
			}
		},

		{
			path: '/session/redirect/:sessionId/:sessionType/:token',
			name: 'session-view-redirect',
			props: true,
			component: () => import('@/pages/home/SessionViewRedirect'),
			meta: {}
		}
	])

]

function middleware (middleware, routes) {
	routes.forEach(route =>
		(route.middleware || (route.middleware = [])).unshift(middleware)
	)

	return routes
}



// WEBPACK FOOTER //
// ./src/router/routes.js